module.exports = __webpack_public_path__ + "static/media/4.15692861.jpg";